/**
 * Abstraction in charge on keep a relationship between actions types and Axios' cancellers.
 * It's useful to cancel requests when dispatching the same action type consecutively.
 */
class Cancellation {
  constructor() {
    this.dictionary = {}
  }

  register(actionType, canceller) {
    if (!actionType) {
      return
    }

    this.dictionary = { ...this.dictionary, [actionType]: canceller }
  }

  run(actionType = '') {
    const canceller = this.dictionary[actionType]

    if (typeof canceller !== 'function') {
      return
    }

    canceller()
  }
}

/**
 * Factory to create a Cancellation instance and expose it as a singleton.
 */
const factoryCancellationSingleton = () => {
  const instance = new Cancellation()

  return () => instance
}

/**
 * To get the Cancellation singleton.
 */
const cancellationSingleton = factoryCancellationSingleton()

export default cancellationSingleton
